import React from 'react';
import type { RaterXCoverage } from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';
import type { AniFormValues } from '../AdditionalNamedInsuredModal';
import { AdditionalNamedInsuredModal } from '../AdditionalNamedInsuredModal';
import type { AniValue } from '../../amendatory-coverages/line-items/AdditionalNamedInsured';
import {
  formatAniForState,
  getDefaultAniFields,
} from '../../amendatory-coverages/line-items/AdditionalNamedInsured';
import type { ContextTypes } from '../../amendatory-coverages/manager';

const RaterXAdditionalNamedInsuredModal = ({
  data,
  close,
  context,
}: ModalProps) => {
  const onSubmit = (formValues: AniFormValues) => {
    const _ani = formatAniForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          items: { values: _ani },
        },
      },
    });
  };

  return (
    <AdditionalNamedInsuredModal
      close={close}
      data={{
        onSubmit,
        context,
        options: (data.coverageState.rules?.items?.options ?? []) as string[],
        aniValues: getDefaultAniFields(
          data.coverageState?.value?.props?.items?.values as AniValue,
          data.coverageState.rules?.items?.options as string[]
        ),
      }}
    />
  );
};

export const RaterXAdditionalNamedInsuredModalConfig = (
  context: ContextTypes
) => {
  return {
    RaterXAdditionalNamedInsuredModal: {
      component: (props: any) => (
        <RaterXAdditionalNamedInsuredModal {...props} context={context} />
      ),
      config: {
        title: 'Add/Edit Additional Named Insureds',
        maxWidth: 'sm',
      },
    },
  };
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
    accountId: string;
  };
  close: () => void;
  context: ContextTypes;
};
